var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisio48X1 = function SvgVisio48X1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "visio_48x1_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".visio_48x1_svg__cls-1{fill:#fff}.visio_48x1_svg__cls-2{fill:#3955a3}"))), /*#__PURE__*/React.createElement("g", {
    id: "visio_48x1_svg___48",
    "data-name": 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 30,
    x: 23,
    y: 9,
    className: "visio_48x1_svg__cls-1",
    rx: 1,
    ry: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 10v28H24V10zm0-2H24a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h19a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2",
    className: "visio_48x1_svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m41.89 16.74-4.63-4.63a.37.37 0 0 0-.52 0L32.85 16H28v2h4.85L36 21v8h-3v-3a1 1 0 0 0-1-1h-4v2h3v6h-3v2h4a1 1 0 0 0 1-1v-3h4a1 1 0 0 0 1-1v-9l3.89-3.74a.37.37 0 0 0 0-.52m-3.74 2.11L37 20l-1.16-1.16-.69-.69L34 17l1.16-1.16L37 14l3 3Z",
    className: "visio_48x1_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28 3 3 7.38v33.24L28 45Z",
    style: {
      fill: "#3955a3",
      fillRule: "evenodd"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16.15 16.26 33l-3.47-.11L8.21 16h3.26l2.82 11.78a9.2 9.2 0 0 1 .27 1.69h.06a10.7 10.7 0 0 1 .29-1.72l2.83-11.67Z",
    className: "visio_48x1_svg__cls-1"
  }))));
};
export default SvgVisio48X1;